import { axiosInstance, axiosJsonInstance } from "@/axios.instance";
import { AxiosResponse } from "axios";
import { ReportFavoriteData } from "@/store/reports/types";

export interface reportApiResponse {
	success: boolean;
	errors: string[];
	warnings: string[];
	confirmations: string[];
	result: ReportFavoriteData | ReportFavoriteData[] | ReportHistoryData[];
}

export interface ReportHistoryData {
	insightsHistoryID: number;
	userID: number;
	url: string;
	runDateTime: Date;
}

class ImmixCloudV2ApiHttpInsightReports {
	private axios: any;
	private axiosJson: any;

	readonly requestStatusSuccessful: number = 200;

	constructor() {
		this.axios = axiosInstance;
		this.axiosJson = axiosJsonInstance;
	}

	public async createFavoriteReport(favoriteReport: ReportFavoriteData): Promise<reportApiResponse> {
		let response: AxiosResponse = await this.axiosJson.post("/Report/Favorites", favoriteReport);
		let returnData: reportApiResponse = {
			success: false,
			errors: ["Error: Couldn't connect to the server, please try again or contact an Administrator."],
			warnings: [],
			confirmations: [],
			result: null
		};

		if (response != undefined && response.status == this.requestStatusSuccessful) {
			return response.data;
		}

		return returnData;
	}

	public async getFavoriteReports(): Promise<ReportFavoriteData[]> {
		let response: AxiosResponse<reportApiResponse> = await this.axiosJson.get("/Report/Favorites");
		let data: ReportFavoriteData[] = [];

		if (response != undefined && response.status == this.requestStatusSuccessful) {
			data = response.data.result as ReportFavoriteData[];
		}

		return data;
	}

	public async removeFavoriteReport(insightsFavoriteID: number) {
		let response: AxiosResponse = await this.axios.delete(`/Report/Favorites/`, {
			params: {
				insightsFavoriteID
			}
		});
		let returnData: reportApiResponse = {
			success: false,
			errors: ["Error: Couldn't connect to the server, please try again or contact an Administrator."],
			warnings: [],
			confirmations: [],
			result: null
		};

		if (response != undefined && response.status == this.requestStatusSuccessful) {
			return response.data;
		}

		return returnData;
	}

	public async getReportHistory(page: number): Promise<reportApiResponse> {
		let response: AxiosResponse = await this.axiosJson.get("/Report/History/" + page);
		let returnData: reportApiResponse = {
			success: false,
			errors: ["Error: Couldn't connect to the server, please try again or contact an Administrator."],
			warnings: [],
			confirmations: [],
			result: null
		};

		if (response != undefined && response.status == this.requestStatusSuccessful) {
			return response.data;
		}

		return returnData;
	}

	public async deleteReportHistory(insightsHistoryID: number): Promise<reportApiResponse> {
		let response: AxiosResponse = await this.axios.delete(`/Report/History`, {
			params: {
				insightsHistoryID
			}
		});
		let returnData: reportApiResponse = {
			success: false,
			errors: ["Error: Couldn't connect to the server, please try again or contact an Administrator."],
			warnings: [],
			confirmations: [],
			result: null
		};

		if (response != undefined && response.status == this.requestStatusSuccessful) {
			return response.data;
		}

		return returnData;

	}

}

const insightReportsApi = new ImmixCloudV2ApiHttpInsightReports();
export default insightReportsApi;
